import React from 'react';
import { Target } from 'lucide-react';
import { ORIGENES } from './leadOrigen';
import { ETAPAS } from './SubscribersTable';

const BAR_COLORS = { web: 'from-slate-400 to-slate-300', comparador: 'from-cyan-500 to-sky-400', chat: 'from-fuchsia-500 to-pink-400' };

export const OrigenFunnel = ({ byOrigen }) => {
  const rows = (byOrigen || []).map((r) => ({ ...r, meta: ORIGENES.find((o) => o.value === r.origen) || ORIGENES[0] }));
  const maxTotal = Math.max(1, ...rows.map((r) => r.total));
  const best = rows.reduce((acc, r) => (r.cerrado > (acc?.cerrado ?? 0) ? r : acc), null);

  return (
    <div className="bg-white/5 border border-white/10 rounded-3xl p-6" data-testid="admin-origen-funnel">
      <div className="flex items-start justify-between gap-4 mb-6">
        <div>
          <h2 className="text-lg font-semibold">Leads cerrados por origen</h2>
          <p className="text-slate-400 text-sm">Qué canal convierte más: formulario web, comparador o chat IA (leads activos)</p>
        </div>
        {best && best.cerrado > 0 && (
          <div className="text-right shrink-0" data-testid="admin-origen-best">
            <p className="text-[10px] uppercase tracking-wider text-slate-400 flex items-center justify-end gap-1"><Target className="h-3 w-3 text-emerald-400" /> Mejor canal</p>
            <p className="font-semibold text-emerald-300">{best.meta.label}</p>
          </div>
        )}
      </div>
      <div className="space-y-5">
        {rows.map((r) => (
          <div key={r.origen} data-testid={`admin-origen-row-${r.origen}`}>
            <div className="flex justify-between text-sm mb-1.5 gap-2">
              <span className="font-medium">{r.meta.label}</span>
              <span className="text-slate-400 text-right">
                <span className="text-emerald-300 font-semibold" data-testid={`admin-origen-cerrados-${r.origen}`}>{r.cerrado}</span> cerrados de <span className="text-white font-semibold">{r.total}</span> · {r.tasa_cierre}%
              </span>
            </div>
            <div className="h-3 rounded-full bg-white/10 overflow-hidden flex" title={ETAPAS.map((e) => `${e.label}: ${r[e.value] ?? 0}`).join(' · ')}>
              <div className="h-full bg-gradient-to-r from-emerald-500 to-emerald-400 transition-[width] duration-700" style={{ width: `${(r.cerrado / maxTotal) * 100}%` }}></div>
              <div className={`h-full bg-gradient-to-r ${BAR_COLORS[r.origen]} opacity-50 transition-[width] duration-700`} style={{ width: `${((r.total - r.cerrado) / maxTotal) * 100}%` }}></div>
            </div>
          </div>
        ))}
        {!byOrigen && <p className="text-slate-500 text-sm">Cargando...</p>}
        {byOrigen && rows.every((r) => r.total === 0) && <p className="text-slate-500 text-sm">Aún no hay leads activos.</p>}
      </div>
      <p className="text-xs text-slate-500 mt-4 flex items-center gap-3"><span className="inline-block h-2 w-4 rounded bg-emerald-400"></span> Cerrados <span className="inline-block h-2 w-4 rounded bg-slate-400/50"></span> En seguimiento</p>
    </div>
  );
};

export default OrigenFunnel;
